module.exports = __webpack_public_path__ + "static/media/mapMarkerClosed.fb98c5dd.svg";